import React, { useMemo } from 'react'
import {
  FormCheckboxInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { BasePublisherCheckbox } from '../checkbox/base-publisher-checkbox'
import { useFormContext } from './context/form-context'

interface FormCheckboxSubentityProps {
  formEntity: FormInterface
  checkboxSubentity: FormCheckboxInterface
}

export const FormCheckboxSubentity = ({
  formEntity,
  checkboxSubentity,
}: FormCheckboxSubentityProps) => {
  const { checkboxesValues, setCheckboxesValues } = useFormContext()
  const entity = useMemo(
    () => ({
      ...checkboxSubentity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubentity, formEntity.checkboxesCommonStyles],
  )
  return (
    <BasePublisherCheckbox
      entityOrSubEntity={entity}
      checked={checkboxesValues[checkboxSubentity.id]}
      onChange={() => {
        setCheckboxesValues({
          ...checkboxesValues,
          [checkboxSubentity.id]: !checkboxesValues[checkboxSubentity.id],
        })
      }}
    />
  )
}
